import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<a class=\"form-link form-link--with-spacing\" href=\"#\" {{action \"editLocations\"}}>\n  {{this.subunitsLabel}}\n</a>", {
  moduleName: "@dashboard/shared-ui/components/sq-catalog-location-picker.hbs"
});